import React from 'react'
import Tabs from '../../components/simple/tabs/Tabs'

function ServiceSetupTabs ({ sections, activeIndex, onActive }) {
  const content = [
    { name: 'General', content: <>{sections.details}{sections.techniques}{sections.clickers}</> },
    { name: 'Permissions', content: sections.permissions },
    { name: 'Notifications', content: <>{sections.recipients}{sections.rules}</> },
    { name: 'Prejudice-related Incidents', content: sections.pil },
    { name: 'Integrations', content: <>{sections.ai}{sections.wonde}{sections.cpoms}</> }
  ]

  return <Tabs content={content} activeIndex={activeIndex} onActive={onActive} />
}

export default ServiceSetupTabs
